module.exports = __webpack_public_path__ + "static/img/guide-12.e1744099.png";